import { RouteRecordRaw } from 'vue-router';

// integrations/routes.ts
export const integrationRoutes = [
  {
    path: '/integrations',
    name: 'integrations',
    component: () => import('./IntegrationList.vue'),
    meta: {
      title: 'Entegrasyonlar',
      requiresAuth: true,
      hideNavbar: false,
      requiredPermissions: 'INTEGRATION_VIEW'
    }
  },
  {
    path: '/integrations/:id',
    name: 'integration-detail',
    component: () => import('./IntegrationDetail.vue'),
    meta: {
      title: 'Entegrasyon Detayı',
      requiresAuth: true,
      hideNavbar: false,
      requiredPermissions: 'INTEGRATION_VIEW'
    }
  },
  {
    path: '/integrations/:integrationId/tables/:tableId',
    name: 'table-detail',
    component: () => import('./TableDetail.vue'),
    meta: {
      title: 'Tablo Detayı',
      requiresAuth: true,
      hideNavbar: false,
      requiredPermissions: 'INTEGRATION_VIEW'
    }
  },
  {
    path: '/integrationSetup',
    name: 'integrationSetup',
    component: () => import('./IntegrationSetup.vue'),
    meta: {
      title: 'Entegrasyon Kurulumu',
      requiresAuth: true,
      hideNavbar: false,
      requiredPermissions: ['INTEGRATION_CREATE', 'INTEGRATION_UPDATE']
    }
  }
] satisfies RouteRecordRaw[];
